var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-3 white--text subheading pre-wrap overflow-hidden",style:({
		backgroundColor: '#00cbb7',
		height: _vm.isFullView ? 'auto' : '200px'
	})},[_vm._v("\n\t"+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }